var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"default-table"},[_c('ApeTable',{ref:"apeTable",attrs:{"data":_vm.dataList,"columns":_vm.columns,"loading":_vm.loadingStatus,"pagingData":_vm.pagingData,"highlight-current-row":""},on:{"switchPaging":_vm.switchPaging}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }